import React from "react";
import { Routes, Route } from "react-router-dom"
import About from "../components/About";
import Cv from "../components/Cv";
import Home from "../components/Home";
import { BingoBoard } from '../components/Binogboard'
import { carBingoObjects } from '../components/carBingoObjects'
import { personBingoObjects } from '../components/personBingoObjects'
import { BingoBoardChoosePage } from '../components/BingoBoardChoosePage'


const AppRoutes: React.FC = () => (
    <Routes>
        <Route path="/cv" element={<Cv />}/>
        <Route path="/about" element={<About />}/>
        <Route path="/home" element={<Home />}/>
        <Route path="/bilbingo" element={<BingoBoard bingoObjects={carBingoObjects()}/>} />
        <Route path="/personbingo" element={<BingoBoard bingoObjects={personBingoObjects}/>} />
        <Route path="/" element={<BingoBoardChoosePage />}/>
    </Routes>
)

export default AppRoutes;